module.exports = __webpack_public_path__ + "static/media/hamburguer.black.ee75954e.svg";